<template>
  <header class="navbar navbar-expand-lg navbar-light bg-light sticky-top p-2">
    <div class="container-fluid">

      <a class="navbar-brand d-flex align-items-center m-0" :href="homeLink">
        <img :src="logoSmallURL" alt="Logo PBH" style="height: 60px; width: auto;" />
        <span class="sigla">{{ sigla }}</span>
      </a>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">

        <div class="navbar-nav mb-2 mb-lg-0">
          <menu-itens v-if="showMenu" :itensMenu="itensMenu" :logoutCallback="logoutCallback"></menu-itens>
        </div>

        <div class="mx-auto my-2 my-lg-0 text-center">
          <strong class="text-danger" v-if="ambiente.length > 0">{{ ambiente }}</strong>
        </div>

        <div class="d-flex justify-content-center justify-content-lg-end mt-2 mt-lg-0 ms-lg-auto">
          <menu-usuario v-if="showMenu && usuario" :nomeUsuario="usuario.name" :logoutCallback="logoutCallback">
          </menu-usuario>
        </div>

      </div>

    </div>
  </header>
</template>

<script>
export default {
  name: "Topo",
  components: {
    "menu-itens": require("./MenuItensSimples").default,
    "menu-usuario": require("./MenuUsuario").default,
  },
  props: {
    logoURL: {
      type: String,
      default: "",
    },
    logoSmallURL: {
      type: String,
      default: "",
    },
    sigla: {
      type: String,
      default: "",
    },
    showMenu: {
      type: Boolean,
      default: true,
    },
    itensMenu: {
      type: Array,
      default: () => [{}],
    },
    usuario: {
      type: Object,
      default: () => { },
    },
    logoutCallback: {
      type: Function,
      default: () => { },
    },
    homeLink: {
      type: String,
      default: "login",
    },
    ambiente: {
      type: String,
      default: "",
    },
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    },
    currentRouteAdmin() {
      return this.currentRoute == "/admin";
    },
    currentRouteRoot() {
      return this.currentRoute == "/";
    },
  },
  methods: {},
  mounted() { },
};
</script>

<style scoped>
.active {
  opacity: 1;
  visibility: visible;
  border-left-color: #4db6ac;
  margin-left: 2px;
  transition: all 0.25s;
}

.sigla {
  display: inline-block;
  font-size: 25px;
  line-height: 25px;
  color: #646455;
  letter-spacing: 3px;
  padding-left: 0.4em;
}

@media screen and (min-width: 320px) {
  .sigla {
    font-size: calc(20px + 6 * ((100vw - 320px) / 680));
  }
}

@media screen and (min-width: 1000px) {
  .sigla {
    margin-left: 0.4em;
    font-size: 25px;
  }
}
</style>
